import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "@common/services/api.service";
import {ApplicationResponse} from "@common/domain/common.model";
import {MastersInfoDataModel, PackagesStore} from "@views/rework/domain/packaging.model";

export const getMastersInfo = createAsyncThunk<MastersInfoDataModel, string>("package/getMastersList", async (serialId) => {
    const response = await api.get<ApplicationResponse<MastersInfoDataModel>>(`master/${serialId}`)
    return response.data.data || {} as MastersInfoDataModel
})


const PackageSlice = createSlice({
    name: "package",
    initialState: {
        masterInfo: {
            status: "empty",
            data: {},
            error: null
        },
        tennerInfo: {
            status: "empty",
            data: {},
            error: null
        }
    } as PackagesStore,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getMastersInfo.pending, (state) => {
                state.masterInfo.status = "loading"
                state.masterInfo.error = null
                state.masterInfo.data = {} as MastersInfoDataModel
            }
        ).addCase(getMastersInfo.fulfilled, (state, action) => {
            state.masterInfo.status = "idle"
            state.masterInfo.data = action.payload as MastersInfoDataModel
            state.masterInfo.error = null
        }).addCase(getMastersInfo.rejected, (state, action) => {
            state.masterInfo.status = "failed"
            state.masterInfo.error = action.error.message
            state.masterInfo.data = {} as MastersInfoDataModel
        })
    }
})

export default PackageSlice.reducer